import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { articleConditionClassConfig } from './ArticleConditionClass.name';

/** 物件状態区分のENUM */
enum ArticleConditionClass {
  /** 契約中 */
  underContract = '1',
  /** 満了済 */
  expired = '2',
  /** 解約済 */
  contractCanceled = '3',
}

const articleConditionClassMap = new Map([
  ['1', ArticleConditionClass.underContract],
  ['2', ArticleConditionClass.expired],
  ['3', ArticleConditionClass.contractCanceled],
]);

const rawValueToArticleConditionClass = rawValueToEnumWithDefault(
  articleConditionClassMap,
  ArticleConditionClass.underContract,
);

const articleConditionClassToDisplay = enumToNameWithDefault(
  ArticleConditionClass,
  articleConditionClassConfig,
);

const articleConditionClassToDisplayWithPrefix = enumToNameWithDefault(
  ArticleConditionClass,
  articleConditionClassConfig,
  true,
);

export {
  ArticleConditionClass,
  articleConditionClassToDisplay,
  articleConditionClassToDisplayWithPrefix,
  rawValueToArticleConditionClass,
};
